import { Box, Tooltip, Typography, useTheme, alpha, Link, ClickAwayListener, Backdrop } from "@mui/material";
import { FC, useEffect, useState } from "react"
import { useLocation, useNavigate } from "react-router-dom";

import { useActions } from "../../hooks/useActions";
import { useTypedSelector } from "../../hooks/useTypedSelector";

import LinkRouter from "../LinkRouter";
import { IAppBarItem } from "../../containers/DefaultLayout/Header";
import { SelectedTypographyStyle, TypographyStyle } from "../../containers/DefaultLayout/styled";

const HeaderDropdownMenu: FC<IAppBarItem> = (item) => {
    const { palette } = useTheme();
    const location = useLocation();
    const navigate = useNavigate();

    const { GetHeaderProjects } = useActions();
    const { projects, projectsCount } = useTypedSelector((store) => store.announcementUser);

    const [open, setOpen] = useState<boolean>(false)

    let isProjectInList: boolean = false;

    useEffect(() => {
        getData();
    }, [])

    const getData = async () => {
        try {
            await GetHeaderProjects(true, "", "", 1, 10, null);
        } catch (ex) {
        }
    };

    useEffect(() => {
        if (open) {
            document.body.style.overflow = "hidden";
        } else {
            document.body.style.overflow = "";
        }
        return () => {
            document.body.style.overflow = "";
        };
    }, [open]);


    return (
        <>
            <Box
                sx={{ cursor: "pointer" }}
                onClick={() => { setOpen(!open); }}
            >
                {(location.pathname === item.path || location.pathname.startsWith(`${item.path}/`))
                    ? <SelectedTypographyStyle>
                        {item.lable}
                    </SelectedTypographyStyle>
                    : <TypographyStyle>
                        {item.lable}
                    </TypographyStyle>
                }
            </Box>
            <Backdrop
                sx={
                    (theme) => ({
                        color: '#fff',
                        zIndex: theme.zIndex.drawer + 1,
                        alignItems: "flex-start",
                        justifyContent: "center",
                        pt: "60px"
                    })}
                open={open}
                onClick={() => setOpen(false)}
            >
                <Box sx={{ width: "150px", background: palette.background.default, borderRadius: "6px", "&:last-child": { mb: 0 } }} >
                    {projects.map((item, index) => {
                        if (location.pathname === `/projects/${item.urlSlug}` && index !== 9)
                            isProjectInList = true;

                        if (index !== 9)
                            return (
                                <Link
                                    key={`header_tooltip_item_${index}`}
                                    underline="none"
                                    color="inherit"
                                    href={`/projects/${item.urlSlug}`}
                                    onClick={() => setOpen(false)}
                                >
                                    <Typography
                                        component="h5"
                                        fontSize="14px"
                                        lineHeight="22px"
                                        fontFamily="Fixel Display, sans-serif"
                                        sx={{
                                            transition: "background 0.4s ease",
                                            background: (location.pathname === `/projects/${item.urlSlug}`) ? alpha(palette.primary.light, 0.35) : "transparent",
                                            '&:hover': {
                                                background: alpha(palette.primary.light, 0.35),
                                            },
                                            borderRadius: "4px",
                                            mb: "4px",
                                            p: "9px 16px"
                                        }}
                                        noWrap
                                    >
                                        {item.title}
                                    </Typography>
                                </Link>
                            );
                        else
                            return (
                                <LinkRouter
                                    key={`header_tooltip_item_${index}`}
                                    underline="none"
                                    color="inherit"
                                    to={`/projects`}
                                    onClick={() => setOpen(false)}
                                >
                                    <Typography
                                        component="h5"
                                        fontSize="14px"
                                        lineHeight="22px"
                                        fontFamily="Fixel Display, sans-serif"
                                        sx={{
                                            transition: "background 0.4s ease",
                                            background: (!(location.pathname.startsWith(`/projects/`)) || isProjectInList) ? "transparent" : alpha(palette.primary.light, 0.35),
                                            '&:hover': {
                                                background: alpha(palette.primary.light, 0.35),
                                            },
                                            borderRadius: "4px",
                                            mb: "4px",
                                            p: "9px 16px"
                                        }}
                                        noWrap
                                    >
                                        Показати більше...
                                    </Typography>
                                </LinkRouter>
                            )
                    })}
                </Box>
            </Backdrop>

        </>
    )
}

export default HeaderDropdownMenu